export default __webpack_public_path__ + "dist/media/Resend-2.e57a4594.svg";